import React from 'react'
import CustomPivotTable from '../../../common/CustomPivotTable'
import { dataValue } from './utils'


const dataUpdate = (pivotData) => pivotData.map(data => {
    return {
        ...data,
        symbol: data.symbol.split('.').join(' '),
        winner: `${data.login} - ${data.name}`,
        game: data.symbolPath
    }
})

const columnsName = [dataValue.ProfitOpen, dataValue.NetExposure, dataValue.ProfitOpenPeriod, dataValue.ProfitClosed, dataValue.PositionCount, dataValue.TradeCount]


function TopExposureInstrument({ data, tabName }) {
    return <>
        <CustomPivotTable
            tableData={dataUpdate(data)}
            values={[
                { name: dataValue.ProfitOpen, caption: 'Open P/L', },
                { name: dataValue.ProfitOpenPeriod, caption: 'Open P/L Period' },
                { name: dataValue.ProfitClosed, caption: 'Closed P/L' },
                { name: dataValue.NetExposure, caption: 'Net Expo USD' },
                { name: dataValue.PositionCount, caption: 'Position' },
                { name: dataValue.TradeCount, caption: 'Trade' },
            ]}
            rows={[
                { name: dataValue.Game },
                { name: dataValue.Symbol },
                { name: dataValue.Winner },
            ]}
            columns={[
                //{ name: dataValue.Book }
            ]}
            showGroupingBar={true}
            columnsName={columnsName}
            sortBy={'Net Expo USD'}
            tabName={tabName}

        />
    </>
}

export default TopExposureInstrument